'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

exports.default = createGetFormInitialValues;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormInitialValues.js
// module id = 1123
// module chunks = 0